import AncillaryDescriptionUIModel from '../../cms-wrapper/ancillary-description';
import asyncActionTypes from '../actions/types.js';

const initialState = {
  loadingAncillaryCollection: false,
  ancillaryDescriptions: {},
  errorAncillariesCms: null,
  totalFlyGreen: 0,
};

const ancillaries = ( state = initialState, action ) => {
  switch (action.type) {
    case asyncActionTypes.RETRIEVE_CMS_ANCILARIES.START:
      return {
        ...state,
        loadingAncillaryCollection: true,
      };
    case asyncActionTypes.RETRIEVE_CMS_ANCILARIES.SUCCESS:
      const ancillaryDescriptions = action.payload.ancillaries;
      const ancillaryDescriptionsByType = {};

      for (let i = 0; i < ancillaryDescriptions.length; i++) {
        ancillaryDescriptionsByType[ancillaryDescriptions[i].ancillary.type] =
        new AncillaryDescriptionUIModel(ancillaryDescriptions[i].ancillary);
      }

      return {
        ...state,
        loadingAncillaryCollection: false,
        errorAncillariesCms: null,
        ancillaryDescriptions: { ...ancillaryDescriptionsByType },
      };
    case asyncActionTypes.RETRIEVE_CMS_ANCILARIES.FAIL:
      return {
        ...state,
        loadingAncillaryCollection: false,
        errorAncillariesCms: action.error,
        ancillaryDescriptions: {},
      };
    case asyncActionTypes.SET_STATE_CHUBB:
      return {
        ...state,
        stateChubb: action.setStateChubb,
      };
    case asyncActionTypes.PREVIEW_STATE_CHUBB:
      return {
        ...state,
        statePreview: action.previewState,
      };
    case asyncActionTypes.SET_TOTAL_FLYGREEN:
      return {
        ...state,
        totalFlyGreen: action.setTotalFlyGreen,
      };
    default:
      return state;
  }
};

export default ancillaries;
